import React from 'react';
import { Table, Dialog, Divider, TableRow, MenuItem, FontIcon, TableBody, TableHeader, SelectField, AutoComplete, RaisedButton, TableRowColumn, TableHeaderColumn } from 'material-ui';
import moment from 'moment';
import { connect } from 'react-redux';
import { Row, Col } from 'reactstrap';
import { Field, reduxForm } from 'redux-form/immutable';
import { SelectFieldF, DatePickerF, AutoCompleteF, CheckBoxFieldF } from 'modules/forms/component';
import { Map } from 'immutable';

import { dias } from 'core/constants';
import * as abonadosActions from '../action';
import * as rutinaActions from 'modules/rutinas/action';
import * as paradasActions from 'modules/paradas/action';
import * as validations from 'modules/forms/validations';
import * as trayectosActions from 'modules/trayectos/action';

const hoy = moment();
/*
{
trayectoId: {
dia: [] <- ordenado por fechaDesde
}
}
*/
@connect((store) => ({
  rutinas: store.getIn(['rutinas', 'lista']),
  paradas: store.getIn(['paradas', 'lista']),
  trayectos: store.getIn(['trayectos', 'lista']),
  reservasAutomaticas: store.getIn(['abonados', 'abonadoReservasAutomaticas']),
}))
class RA extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      trayectoId: false,
      openRA: false,
    };
  }
  componentDidMount() {
    const { rutinas, paradas, trayectos, dispatch } = this.props;
    rutinas.size == 0 && dispatch(rutinaActions.get());
    trayectos.size == 0 && dispatch(trayectosActions.get());
    paradas.size == 0 && dispatch(paradasActions.get());
  }
  componentWillUnmount = () => this.props.dispatch(abonadosActions.clear('abonadoReservasAutomaticas'));
  selectTrayecto = (trayectoId) => {
    this.setState({ trayectoId });
    trayectoId && this.props.dispatch(abonadosActions.getTrayectosParadas(trayectoId));
  };
  deleteRa = ({ id, path }) => this.props.dispatch(abonadosActions.delRA(id, path));
  copiarRA = () => {
    const { reservasAutomaticas, dispatch, abonadoId, isUser } = this.props,
      { trayectoId } = this.state,
      RA = reservasAutomaticas.getIn([trayectoId, 1, 0]);
    if (RA) {
      [2, 3, 4, 5].map(
        (dia) =>
          !reservasAutomaticas.getIn([trayectoId, dia, 0]) && setTimeout(() => dispatch(abonadosActions.setReservasAutomaticas(Object.assign(RA.toJS(), { dia }), abonadoId, isUser)), (dia - 2) * 300),
      );
    }
  };
  render() {
    const { trayectos, abonadoId, paradas, reservasAutomaticas, isUser, rutinas } = this.props,
      { trayectoId, openRA } = this.state;
    return (
      <div>
        <Row>
          <Col md={{ size: 7, offset: 1 }}>
            <SelectField
              floatingLabelText="Trayecto"
              fullWidth={true}
              maxHeight={300}
              value={trayectoId}
              disabled={abonadoId == 'new'}
              onChange={(e, index, trayectoId) => this.selectTrayecto(trayectoId)}
            >
              <MenuItem value={false} primaryText="No seleccionado" />
              {trayectos.map((trayecto) => {
                const trayectoId = trayecto.get('id');
                return <MenuItem key={trayectoId} value={trayectoId} primaryText={trayecto.get('subnombre') ? trayecto.get('nombre') + ' - ' + trayecto.get('subnombre') : trayecto.get('nombre')} />;
              })}
            </SelectField>
          </Col>
          <Col md="3">
            <RaisedButton
              className="fullWidthComponent noPadding m-tb-20"
              label="Cargar semana"
              primary={true}
              disabled={abonadoId == 'new' || !trayectoId || !reservasAutomaticas.getIn([trayectoId, 1, 0])}
              onClick={() => this.copiarRA()}
            />
          </Col>
        </Row>
        <Divider />
        <Table selectable={false} multiSelectable={false}>
          <TableHeader displaySelectAll={false} adjustForCheckbox={false}>
            <TableRow>
              <TableHeaderColumn colSpan="1">Dia</TableHeaderColumn>
              <TableHeaderColumn colSpan="1" tooltip="Fecha en que inicia la creacion de las reservas">
                Fecha inicio
              </TableHeaderColumn>
              <TableHeaderColumn colSpan="1" tooltip="Fecha hasta las que se crearan las reservas">
                Fecha fin
              </TableHeaderColumn>
              <TableHeaderColumn tooltip="Horario del viaje">Horario</TableHeaderColumn>
              <TableHeaderColumn colSpan="3" tooltip="Parada en la que sube">
                Parada de salida
              </TableHeaderColumn>
              <TableHeaderColumn colSpan="2" tooltip="Al estar activas se crearan las reservas">
                Activa
              </TableHeaderColumn>
              <TableHeaderColumn colSpan="2"> </TableHeaderColumn>
            </TableRow>
          </TableHeader>
          <TableBody displayRowCheckbox={false} showRowHover={trayectoId ? true : false}>
            {dias.map((dia, i) =>
              reservasAutomaticas.getIn([trayectoId, i]) && reservasAutomaticas.getIn([trayectoId, i]).size > 0 ? (
                reservasAutomaticas.getIn([trayectoId, i]).map((RA, index) => {
                  let paradaSubida = false,
                    inmIndex = false;
                  inmIndex = paradas.find((p) => p.get('id') == RA.get('paradaSubida'));
                  if (inmIndex) paradaSubida = inmIndex.get('fullName');

                  return (
                    <TableRow key={index * Math.random()}>
                      <TableRowColumn colSpan="1" className="capitalize">
                        {index == 0 && dia}
                      </TableRowColumn>
                      <TableRowColumn colSpan="1">{moment(RA.get('fechaDesde')).format('DD/MM/YY')}</TableRowColumn>
                      <TableRowColumn colSpan="1">{RA.get('fechaHasta') && moment(RA.get('fechaHasta')).format('DD/MM/YY')}</TableRowColumn>
                      <TableRowColumn>{RA.get('horario')}</TableRowColumn>
                      <TableRowColumn colSpan="3">{paradaSubida}</TableRowColumn>
                      <TableRowColumn colSpan="2">{RA.get('activa') ? 'ACTIVA' : 'INACTIVA'}</TableRowColumn>
                      <TableRowColumn colSpan="2">
                        {trayectoId && (
                          <FontIcon
                            className="fa fa-plus-square pr-10"
                            color={index == 0 ? 'black' : 'rgba(100, 100, 100, 0)'}
                            hoverColor={index == 0 ? 'green' : 'rgba(100, 100, 100, 0)'}
                            onClick={() => index == 0 && this.setState({ openRA: { i } })}
                          />
                        )}
                        {trayectoId && <FontIcon className="fa fa-pencil-square pr-10" color="blue" onClick={() => this.setState({ openRA: { i, edit: RA, pathEdit: [trayectoId, i, index] } })} />}
                        {trayectoId && <FontIcon className="fa fa-trash pr-10" color="red" onClick={() => this.deleteRa({ id: RA.get('id'), path: [trayectoId, i, index] })} />}
                      </TableRowColumn>
                    </TableRow>
                  );
                })
              ) : (
                <TableRow key={i}>
                  <TableRowColumn colSpan="1" className="capitalize">
                    {dia}
                  </TableRowColumn>
                  <TableRowColumn colSpan="2">{trayectoId && <FontIcon className="fa fa-plus-square" hoverColor={'green'} onClick={() => this.setState({ openRA: { i } })} />}</TableRowColumn>
                </TableRow>
              ),
            )}
          </TableBody>
        </Table>
        <ReservaAutomatica open={openRA} isUser={isUser} abonadoId={abonadoId} trayectoId={trayectoId} onRequestClose={() => this.setState({ openRA: false })} />
      </div>
    );
  }
}

class ReservaAutomatica extends React.Component {
  submitForm = (data) => {
    const { trayectoId, open, dispatch, abonadoId, isUser } = this.props;
    let dia = open.i;

    if (open.edit)
      data = {
        RAId: open.edit.get('id'),
        paradaSubida: data.get('paradaSubida'),
        paradaBajada: data.get('paradaBajada'),
        [isUser ? 'usuarioId' : 'abonadoId']: abonadoId,
        activa: data.get('activa'),
      };
    else {
      data = data
        .set('dia', dia)
        .set('trayectoId', trayectoId)
        .set('fechaDesde', data.get('fechaDesde'))
        .set('horario', data.getIn(['rutina', 'horario']))
        .set('grupos', data.getIn(['rutina', 'grupos']))
        .delete('rutina');
      data.get('fechaHasta') && data.set('fechaHasta', moment(data.get('fechaHasta')).toDate());
      data = data.toJS();
    }

    dispatch(abonadosActions.setReservasAutomaticas(data, abonadoId, isUser));
    this.props.reset();
    this.props.onRequestClose();
  };
  componentDidUpdate = (prevProps) => {
    if (this.props.open.edit && prevProps.open.edit != this.props.open.edit) {
      this.props.change('horario', this.props.open.edit.get('horario'));
      this.props.change('fechaDesde', this.props.open.edit.get('fechaDesde'));
      this.props.change('fechaHasta', this.props.open.edit.get('fechaHasta'));
      this.props.change('paradaSubida', this.props.open.edit.get('paradaSubida'));
      this.props.change('paradaBajada', this.props.open.edit.get('paradaBajada'));
      this.props.change('activa', this.props.open.edit.get('activa'));
    }
  };
  render() {
    const { open, onRequestClose, trayectoId, rutinas, handleSubmit, invalid } = this.props,
      paradas = this.props.paradas.filter((p) => this.props.trayectoSeleccionado.getIn(['_trayectoParadas', 'trayectoId']) == p.get('trayectoId')).toJS();

    return (
      <Dialog
        open={!!open}
        modal={false}
        autoScrollBodyContent={true}
        title={`Reserva programable del ${dias[open.i]}`}
        onRequestClose={() => {
          this.props.reset() && onRequestClose();
        }}
      >
        <Row>
          <Col md="3">
            <Field
              name="rutina"
              component={SelectFieldF}
              inputProps={{
                disabled: !!open.edit,
                fullWidth: true,
                floatingLabelText: 'Horario',
                maxHeight: 300,
              }}
              validate={!open.edit && validations.required}
            >
              {rutinas
                .filter((r) => r.get('trayectoId') == trayectoId)
                .map((rutina) => {
                  let primaryText = rutina.get('horario');
                  if (rutina.has('grupos') && rutina.get('grupos').size > 0) primaryText += ' - Pertenece a un grupo';
                  else primaryText += ' - Publico';
                  return rutina.get(dias[open.i]) && <MenuItem key={rutina.get('id')} value={rutina} primaryText={primaryText} />;
                })}
            </Field>
          </Col>
          <Col md="3">
            <Field
              name="fechaDesde"
              component={DatePickerF}
              className="fullWidthComponent minHeight55"
              inputProps={{
                disabled: !!open.edit,
                autoOk: true,
                fullWidth: true,
                floatingLabelText: 'Fecha de inicio',
              }}
              format={(value) => (typeof value == 'string' ? null : value)}
              validate={validations.required}
            />
          </Col>
          <Col md="3">
            <Field
              name="fechaHasta"
              component={DatePickerF}
              className="fullWidthComponent minHeight55"
              inputProps={{
                disabled: !!open.edit,
                autoOk: true,
                fullWidth: true,
                floatingLabelText: 'Fecha hasta',
              }}
              format={(value) => {
                return typeof value == 'string' ? null : value;
              }}
            />
          </Col>
          <Col md="3" style={{ paddingTop: 30 }}>
            <Field
              name="activa"
              component={CheckBoxFieldF}
              inputProps={{
                label: 'Activa',
              }}
            />
          </Col>
        </Row>
        <Row>
          <Col md="6">
            <Field
              name="paradaSubida"
              component={AutoCompleteF}
              inputProps={{
                fullWidth: true,
                dataSource: paradas,
                hintText: 'Parada subida',
                dataSourceConfig: { text: 'alias', value: 'id' },
                filter: AutoComplete.caseInsensitiveFilter,
                className: 'h72',
                openOnFocus: true,
              }}
              onBlur={(e) => e.preventDefault()}
              validate={[validations.required, validations.noObject]}
            />
          </Col>
          <Col md="6">
            <Field
              name="paradaBajada"
              component={AutoCompleteF}
              inputProps={{
                fullWidth: true,
                dataSource: paradas,
                hintText: 'Parada bajada',
                dataSourceConfig: { text: 'alias', value: 'id' },
                filter: AutoComplete.caseInsensitiveFilter,
                className: 'h72',
                openOnFocus: true,
              }}
              onBlur={(e) => e.preventDefault()}
              validate={validations.noObject}
            />
          </Col>
        </Row>
        <RaisedButton className="fullWidthComponent noPadding m-tb-20" label="GUARDAR" primary={true} disabled={invalid} onClick={handleSubmit(this.submitForm)} />
        <RaisedButton
          className="fullWidthComponent noPadding"
          label="CANCELAR"
          secondary={true}
          onClick={() => {
            this.props.reset() && onRequestClose();
          }}
        />
      </Dialog>
    );
  }
}

ReservaAutomatica = reduxForm({
  form: 'FORM_RA',
  enableReinitialize: true,
})(ReservaAutomatica);

ReservaAutomatica = connect((store) => ({
  rutinas: store.getIn(['rutinas', 'lista']),
  paradas: store.getIn(['paradas', 'lista']),
  trayectoSeleccionado: store.getIn(['abonados', 'trayectoSeleccionado']),
  initialValues: {
    fechaDesde: hoy.toDate(),
    activa: true,
  },
}))(ReservaAutomatica);

export default RA;



// WEBPACK FOOTER //
// src/modules/abonados/components/reservasAutomaticasTable.js